export default "__VITE_ASSET__0I11efLi__"